export default "__VITE_ASSET__CNoLkTfV__"